import React from 'react';

import GoogleAnalytics from 'react-ga';

import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { Provider } from "mobx-react";

import Sentry from './Sentry';

import Screens from './screens';

import stores from './stores';

import 'bootstrap/dist/css/bootstrap.min.css';

import 'core-js/modules/es6.array.find';
import 'core-js/modules/es7.array.includes';
import 'core-js/fn/array';

import config from './utils/config';

GoogleAnalytics.initialize(config.ga.code, {
    debug: !config.ga.enabled,
});

ReactDOM.render((
    <Sentry>
        <Provider {...stores}>
            <HashRouter>
                <Screens />
            </HashRouter>
        </Provider>
    </Sentry>
  ), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js